(() => {
  const selector = '[data-async-newsletter] form';

  const initializeForm = (form) => {
    if (form.dataset.asyncNewsletterInitialized === 'true') return;

    const fields = form.querySelector('[data-newsletter-form-fields]');
    const successMessage = form.querySelector('[data-newsletter-success]');
    if (!fields || !successMessage) return;

    form.dataset.asyncNewsletterInitialized = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity() || form.dataset.submitting === 'true') return;

      const submitButton = form.querySelector('[type="submit"]');
      form.dataset.submitting = 'true';
      submitButton?.setAttribute('aria-busy', 'true');
      submitButton?.setAttribute('disabled', 'disabled');

      try {
        const response = await fetch(form.action, {
          method: form.method || 'post',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) throw new Error('Newsletter submission failed');

        fields.hidden = true;
        successMessage.hidden = false;
        successMessage.removeAttribute('hidden');
        form.reset();

        document.cookie = 'lbr-newsletter-subscribed=true; max-age=31536000; path=/; SameSite=Lax';
        try {
          window.localStorage.setItem('lbr-newsletter-subscribed', 'true');
        } catch (error) {
          // Cookies remain the fallback when local storage is unavailable.
        }

        document.documentElement.classList.add('lbr-newsletter-subscribed');
        document.querySelectorAll('lbr-newsletter-popup').forEach((popup) => {
          popup.classList.add('is-subscribed');
        });
        document.querySelectorAll('.lbr-newsletter-floater').forEach((floater) => {
          floater.classList.remove('is-visible');
          floater.hidden = true;
        });
        document.dispatchEvent(new CustomEvent('lbr:newsletter-subscribed', { detail: { form } }));
      } catch (error) {
        submitButton?.removeAttribute('disabled');
      } finally {
        delete form.dataset.submitting;
        submitButton?.removeAttribute('aria-busy');
      }
    });
  };

  const initialize = (root = document) => root.querySelectorAll(selector).forEach(initializeForm);

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
